import React from 'react'
import PropTypes from 'prop-types'

import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogContent from '@material-ui/core/DialogContent'
import DialogActions from '@material-ui/core/DialogActions'
import CircularProgress from '@material-ui/core/CircularProgress'

import DeleteIcon from '@material-ui/icons/Delete'
import CancelIcon from '@material-ui/icons/Cancel'

export default function DeleteCategoryDialog (props) {
  const [saving, setSaving] = React.useState(false)

  const handleDeleteCategory = async () => {
    if (saving) {
      // stop multiple presses of save
      return
    }

    setSaving(true)

    await props.onDeleteCategory()

    setSaving(false)
  }

  const handleOnCancel = () => {
    if (saving) {
      return
    }

    props.onClose()
  }

  const handleClose = (event, reason) => {
    // don't close by clicking background
    if (reason === 'backdropClick') {
      return
    }

    props.onClose(event, reason)
  }

  return (
    <Dialog maxWidth="sm" fullWidth={true} onClose={handleClose} open={props.open}>
      <DialogTitle onClose={props.onClose}>
        Delete Category
      </DialogTitle>
      <DialogContent dividers>
        <p>Are you sure you wish to delete the category {props.deleteCategory}?</p>
        <p>This will also delete all of its child categories, and reset all products in these categories to their original category.</p>
      </DialogContent>
      <DialogActions>
        <Button autoFocus variant="contained" onClick={handleDeleteCategory} color="primary">
          {
            saving === true
              ? <><CircularProgress color="inherit" size={20} />&nbsp;</>
              : <><DeleteIcon />&nbsp;</>
          }
          Delete
        </Button>
        <Button variant="contained" onClick={handleOnCancel} color="secondary">
          <CancelIcon />&nbsp;Cancel
        </Button>
      </DialogActions>
    </Dialog>)
}

DeleteCategoryDialog.propTypes = {
  onDeleteCategory: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  deleteCategory: PropTypes.string.isRequired
}
